import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { IMG, FAQS } from "@/data/site";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageHero overline="FAQ" title="Questions, answered" subtitle="Everything you need to know before your stay." image={IMG.roomElegant} />
      <section className="py-24 md:py-32 max-w-3xl mx-auto px-6 md:px-12">
        <FadeUp>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
                <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl font-light text-white hover:text-[#d4af37] hover:no-underline py-6" data-testid={`faq-trigger-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#a3a3a3] leading-relaxed pb-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </section>
    </div>
  );
}
